import type { MissionMembershipRole } from '../contracts/types'
import { ORBIS_MISSION_ID } from '../fixtures/missionPresets'
import { ACME_FILM_MISSION_ID, SCAPES_DEMO_MISSION_ID } from '../fixtures/projectSnapshotRegistry'

/** Explicit membership assignments for read-model tests and dev registry (not universal defaults). */
export const PROJECT_MEMBERSHIP_REGISTRY: Readonly<Record<string, MissionMembershipRole>> =
  Object.freeze({
    [`${ORBIS_MISSION_ID}:harry-staging-uid`]: 'founder',
    [`${ORBIS_MISSION_ID}:orbis-collaborator-uid`]: 'writer',
    [`${ACME_FILM_MISSION_ID}:acme-writer-uid`]: 'writer',
    [`${SCAPES_DEMO_MISSION_ID}:scape-builder-uid`]: 'worldbuilder',
    'omnistudio-package:producer-uid': 'producer',
    'omnicine-timeline:cine-uid': 'cinematic_editor',
    'omnicast-review:reviewer-uid': 'reviewer',
  })

export function lookupProjectMembershipRole(
  projectId: string,
  uid: string | undefined
): MissionMembershipRole | undefined {
  if (!uid) return undefined
  return PROJECT_MEMBERSHIP_REGISTRY[`${projectId}:${uid}`]
}
